import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1),
    width: '100%'
  },
  backAndTitleContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: spacing(1)
  },
  titleSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: spacing(0)
  },
  backButton: {
    marginRight: spacing(1),
    height: '56px',
    padding: 0,
    borderRadius: '4px',
    color: palette.text?.secondary || '#666',
    '&:hover': {
      backgroundColor: palette.action?.hover || 'rgba(0, 0, 0, 0.04)',
      color: palette.primary?.main || '#1976d2'
    }
  },
  contentContainer: {
    padding: spacing(3, 0)
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '70vh',
    gap: spacing(2)
  },
  leftPanel: {
    width: '30%'
  },
  rightPanel: {
    flex: 1
  },
  location: {
    fontSize: '0.875rem',
    color: palette.text?.secondary || '#666',
    marginBottom: spacing(0.5)
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1),
    position: 'relative'
  },
  titleAndStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1.5)
  },
  pageTitle: {
    fontWeight: 600,
    fontSize: '1.5rem'
  },
  publishedChip: {
    backgroundColor: palette.success?.light || '#c8e6c9',
    color: palette.success?.dark || '#2e7d32',
    fontSize: '0.75rem',
    height: 20,
    '& .MuiChip-label': {
      padding: spacing(0, 1)
    }
  },
  draftChip: {
    backgroundColor: palette.grey?.[100] || '#f5f5f5',
    color: palette.grey?.[700] || '#616161',
    fontSize: '0.75rem',
    height: 20,
    '& .MuiChip-label': {
      padding: spacing(0, 1)
    }
  },
  editIcon: {
    color: palette.primary?.main || '#1976d2',
    zIndex: 10,
    position: 'relative',
    '&:hover': {
      backgroundColor: palette.primary?.light || '#e3f2fd'
    }
  }
}))
